export enum enumResponseCodeClassification {
  'ISO' = 1,
  'EDO',
  'EFT',
  'Validation',
  'Internal',
  'FrontEnd',
  'Batch Rejection',
  'MBEngine',
  'EDO ISO',
  'Portal Card Registration',
  'Portal Card ReIssue',
  'Account Administration',
  'Fingerprint Administration',
  'RTC' = 14
}

export namespace enumResponseCodeClassification {
  export function values() {
    return Object.keys(enumResponseCodeClassification).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
